import {UploadedFilePreview} from "./UploadedFilePreview";

export class UploadedFile{

    public readonly id: any;
    public readonly name: string;
    public readonly sizeReadable: string;
    public readonly size: number;
    public readonly type: string;
    public readonly extension: string;
    public readonly preview: UploadedFilePreview;

    constructor(id: any, name: string, sizeReadable: string, size: number, type: string, extension: string,
                preview: UploadedFilePreview) {
        this.id = id;
        this.name = name;
        this.sizeReadable = sizeReadable;
        this.size = size;
        this.type = type;
        this.extension = extension;
        this.preview = preview;
    }
}
